import { atom } from 'jotai';

export const configurationId = atom<string | null>(null);
